import { observer } from 'mobx-react';
import { AddImageIcon, Typography } from '@execonline-inc/execonline-ui';
import { T } from '../../../Translations';

function EmptyLogo() {
  return (
    <div className="w-64 h-36 border border-dashed border-[#DEDEDE] rounded-md bg-[#C5C5C51F] flex flex-col items-center justify-center">
      <AddImageIcon size="xl" className="text-gray-600" />
      <Typography className="text-gray-600 w-32 text-center" variant="bodySmall">
        <T kind="Your organization logo will appear here" />
      </Typography>
    </div>
  );
}

export default observer(EmptyLogo);
